import brandAssetsSource from '@streamlain/brand/brand-assets.json';

export interface StreamLainBrandPathSource {
  transform: string;
  path: string;
}

export interface StreamLainCoreLogoSource {
  /** Compatibility palette aliases for existing theme consumers. */
  primary: string;
  darkBlue: string;
  white: string;
  provenance: {
    flowMarkSha256: string;
    flowLoaderSha256: string;
    wordmarkSha256: string;
  };
  colors: {
    primary: string;
    secondary: string;
    white: string;
  };
  mark: {
    viewBox: string;
    width: number;
    height: number;
    upper: StreamLainBrandPathSource;
    lower: StreamLainBrandPathSource;
  };
  loader: {
    durationMs: number;
    strokeWidth: number;
    upperTrace: string;
    lowerTrace: string;
  };
  wordmark: {
    viewBox: string;
    width: number;
    height: number;
    defaultWidth: number;
    transform: string;
    streamPath: string;
    lainPath: string;
    streamGradient: readonly string[];
    lainGradient: readonly string[];
  };
}

const brandAssets: Omit<
  StreamLainCoreLogoSource,
  'primary' | 'darkBlue' | 'white'
> = brandAssetsSource;

export const STREAMLAIN_CORE_LOGO: StreamLainCoreLogoSource = {
  ...brandAssets,
  primary: brandAssets.colors.primary,
  darkBlue: brandAssets.colors.secondary,
  white: brandAssets.colors.white,
};
